module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#search",
      toString: function () {
        return this.url;
      }
    }